require('dotenv').config()

// export const SERVER_URL = `${process.env.REACT_APP_ADMIN_HOST}:${process.env.REACT_APP_ADMIN_PORT}/admin/api`;
export const SERVER_URL = `/admin/api`;

// z-index above canvas z-index
export const ZINDEX_5 = 16703465
export const ZINDEX_4 = 16703464
export const ZINDEX_3 = 16703463
export const ZINDEX_2 = 16703462
export const ZINDEX_1 = 16703461

export const MTM_TEXT = [
    'Welcome to Utility',
    'Utility Report Arrives',
    'High Bill Coming',
    'Bill Receipt',
    'Call into Call Center',
    'Smart Home Device Installed',
    'Seasonal Change',
    'New Smart Meter',
    'Peak Day',
    'Rate Change',
    'Extreme Weather',
    'Outage',
    'Purchase A Distributed Energy Resource'
]

// ToDo: fix this in chalk or themes if possible.

export const RedwoodPalette = {
    neutralGrey190: '#161513',
    brandGreen100: '#5F7D4F',
    brandSienna100: '#89723F',
    brandNeutral10: '#FBF9F8',
    brandNeutral70: '#AEA8A2',
    brandNeutral170Alpha: 'rgba(49,45,42,0.5)',
    alertBlue90: '#4190AC'
}
